import axios from 'axios'
import store from '../../store'
import { logout, enqueueSnackbar } from './actions'
import { getSagasMsgs } from './selectors'
import { detachDelightedSurvey } from '../../utils'

axios.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status
        const url = error?.config?.url || ''
        const state = store.getState()

        if (
            status === 401 &&
            error?.response?.data?.type === 'FORCED_LOGOUT' &&
            url.startsWith(process.env.API_URL) &&
            state.main.token
        ) {
            const sagasMsgs = getSagasMsgs(state)
            store.dispatch(logout())
            detachDelightedSurvey()
            store.dispatch(
                enqueueSnackbar({
                    message: sagasMsgs.sessionEx,
                    options: {
                        variant: 'error'
                    }
                })
            )
        }

        return Promise.reject(error)
    }
)
